import { cx } from "shared/utils";
import { CriteriaTargetType } from "../../constants";

type Props = {
  group?: boolean;
  title: string;
  className?: string;
};

export const GroupTypeLabel = ({ group = false, title, className }: Props) => {
  return (
    <label className={cx("text-content-1000 font-medium", className)}>
      {title}{" "}
      <span className="text-content-200 font-medium">
        ({group ? CriteriaTargetType.GROUP : CriteriaTargetType.INDIVIDUAL})
      </span>
    </label>
  );
};
